export const deepEqual = (obj1: Object, obj2: Object) => {
  if (obj1 === obj2) {
    return true;
  }

  if (bothObjectsAreNan(obj1, obj2)) {
    return true;
  }

  if (!areBothObjects(obj1, obj2)) {
    return false;
  }

  if (Array.isArray(obj1) && Array.isArray(obj2)) {
    return areArraysEqual(obj1, obj2);
  }

  if (Array.isArray(obj1) !== Array.isArray(obj2)) {
    return false;
  }

  return areObjectsEqual(obj1, obj2);
};

const bothObjectsAreNan = (obj1: Object, obj2: Object): boolean => {
  if (typeof obj1 === 'number' && typeof obj2 === 'number' && isNaN(obj1) && isNaN(obj2)) {
    return true;
  }
  return false;
};

const areBothObjects = (obj1: Object, obj2: Object): boolean => {
  if (typeof obj1 !== 'object' || obj1 === null || typeof obj2 !== 'object' || obj2 === null) {
    return false;
  }
  return true;
};

const areArraysEqual = (arr1: unknown[], arr2: unknown[]): boolean =>
  arr1.length === arr2.length && arr1.every((item, index) => deepEqual(item, arr2[index]));

const areObjectsEqual = (obj1: object, obj2: object): boolean => {
  const keys1 = Reflect.ownKeys(obj1);
  const keys2 = Reflect.ownKeys(obj2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  return keys1.every(key => keys2.includes(key) && deepEqual((obj1 as any)[key], (obj2 as any)[key]));
};

/**
 * Groups the elements of an array according to the string values returned by the key function. The returned object has separate properties for each group, containing arrays with the elements in the group.
 * Same functionality as the new Object.groupBy()
 * @param arr
 * @param fn
 * @returns
 */
export const groupBy = <T>(arr: T[], keyFn: (item: T) => string): Record<string, T[]> => {
  return arr.reduce((groups, val) => {
    const key = keyFn(val);
    groups[key] = groups[key] ?? [];
    groups[key].push(val);
    return groups;
  }, {});
};
